import jsx from '../jsx';

export const changeWrapper =
  <T,>(onChange: (value: T) => void) =>
  (e: Event) => {
    onChange((e.target as HTMLInputElement).value as T);
  };

export const Input = <T extends string>(args: {
  placeholder: string;
  type: string;
  value?: T;
  onChange: (value: T) => void;
  className?: string;
}) => {
  const { placeholder, type, value, onChange, className } = args;

  return (
    <input
      placeholder={placeholder}
      type={type}
      value={value}
      className={className}
      onchange={changeWrapper<T>(onChange)}
    />
  );
};

export const Select = <T extends string>(args: {
  value: T;
  options: T[];
  onChange: (value: T) => void;
  className?: string;
}) => {
  const { value, options, className } = args;

  const select = (
    <select
      value={value}
      className={className}
      onchange={changeWrapper<T>(args.onChange)}
    />
  );

  options.forEach((option) => {
    const optionElement = <option value={option}>{option}</option>;
    select.append(optionElement);
  });

  return select;
};

export const FormGroup = (label: string, children: HTMLElement[]) => {
  const container = (
    <div className="formGroup">
      <label>{label}</label>
    </div>
  );

  children.forEach((child) => container.append(child));
  return container;
};
